if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cartdrawer = document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      //Product view datalayer event
      document.dispatchEvent(new CustomEvent('ProductViewed', {
        detail: {
          country: window.Shopify.country
        }
      }));
    }

async onSubmitHandler(evt) {
  evt.preventDefault();
  const submitButton = this.querySelector('[type="submit"]');
  if (submitButton.classList.contains('loading')) return;

  // Check if cartNotification is defined before calling methods on it
  if (this.cartNotification) {
    this.handleErrorMessage();
    this.cartNotification.setActiveElement(document.activeElement);
  }

  submitButton.setAttribute('aria-disabled', true);
  submitButton.classList.add('loading');
  this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  const config = window.fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('sections', this.cartNotification ? this.cartNotification.getSectionsToRender().map((section) => section.id) : []);
  formData.append('sections_url', window.location.pathname);

  // Add the main product (skate) to formData
  const skateData = new FormData(this.form);
  skateData.forEach((value, key) => {
    formData.append(key, value);
  });
  
  let mainProductKey = null;
  let mainProducttitle = null;
  let mainProductResponse = null;
  let mainproductquantity = null;
   
  config.body = formData;
  
  await fetch(`${window.routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        throw new Error(response.description); // Stop execution if there's an error
      }
      mainProductKey = response.key; // Store the main product key
      mainProducttitle = response.title;
      mainProductResponse = response;
      mainproductquantity = response.quantity;
      
      if (this.dataset.emitAddToCart === 'true') {
        document.dispatchEvent(new CustomEvent('AddToCart', {
          detail: {
            line_item_key: response.key,
            product: response
          }
        }));
      }

      if (this.cartdrawer) {
        this.cartNotification.renderContents(response);
      } else {
        // Redirect to the cart page after successfully adding items
        window.location.href = window.routes.cart_url;
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
	
  const additionalItems = [];
	
  // Add steel product if selection is present
  if (this.dataset.hasSteelSelection === 'true') {
    const steelSelectionEl = this.closest('.shopify-section')?.querySelector('steel-selection')
      || this.closest('#altContainer')?.querySelector('steel-selection')
      || document.querySelector('#altContainer steel-selection');
    const selectedVariant = steelSelectionEl?.selectedSteelVariant;

    if (selectedVariant?.quantity > 0) {
      let hasSufficientQty = true;

      await fetch(`${window.routes.cart_url}`, config)
        .then((response) => response.json())
        .then((cartData) => {
          // Check if the steel is already in the cart associated with the skate
          const selectedSteelLineItems = cartData.items.filter(item => 
            item.variant_id.toString() === selectedVariant.id.toString() && 
            item.properties._associatedWithLineItemKey === mainProductKey
          );
          
          const qtyOfSelectedSteelInCart = selectedSteelLineItems.reduce((total, lineItem) => total + lineItem.quantity, 0);
          const qtyToAdd = Number(formData.get('quantity'));

          // If the quantity of steel already in the cart + quantity to add exceeds the available quantity, alert the user
          if (qtyToAdd && qtyOfSelectedSteelInCart + qtyToAdd > selectedVariant.quantity) {
            alert(window.Resources.pdp.steel_selection.all_remaining_qty_in_cart);
            hasSufficientQty = false;
          }

          // If steel for this skate line already exists, cart/add merges by variant + properties
          // and is additive — pass only the increment, not the desired total quantity.
          if (selectedSteelLineItems.length > 0) {
            additionalItems.push({
              id: selectedSteelLineItems[0].variant_id,
              quantity: qtyToAdd,
              properties: selectedSteelLineItems[0].properties // Keep the same properties (association with skate)
            });
          } else {
            // If the steel is not in the cart, add it as a new line item
            additionalItems.push({
              id: selectedVariant.id,
              quantity: qtyToAdd,
              properties: {
                "_hiddenFromCartCount": true,
                "_associatedWithLineItemKey": mainProductKey,
                "added_with": mainProducttitle
              }
            });
          }
        });

      if (!hasSufficientQty) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }
    }
  }

  // Add wheel products if available
  if (wheelList) {
    const properties = {
      "_hiddenFromCartCount": true,
      "_associatedWithLineItemKey": '', // This will now be set after the main product is added
    };

    for (const id in window.wheelProducts) {
      const wheel = wheelProducts[id];
      if (wheel.qty > 0) {
        const item = {
          id: Number(id),
          quantity: wheel.qty,
          properties: properties,
        };
        additionalItems.push(item);
      }
    }
  }

  // If there are additional items (steel or wheels), send another request to update the cart
  if (additionalItems.length > 0) {
    const additionalFormData = new FormData();
    additionalFormData.append('sections', this.cartNotification ? this.cartNotification.getSectionsToRender().map((section) => section.id) : []);
    additionalFormData.append('sections_url', window.location.pathname);

    additionalItems.forEach((item, index) => {
      additionalFormData.append(`items[${index}][id]`, item.id);
      additionalFormData.append(`items[${index}][quantity]`, item.quantity);
      if (item.properties) {
        for (const propKey in item.properties) {
          additionalFormData.append(`items[${index}][properties][${propKey}]`, item.properties[propKey]);
        }
      }
    });

    config.body = additionalFormData;
    await fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (this.dataset.emitAddToCart === 'true') {
          document.dispatchEvent(new CustomEvent('AddToCart', {
            detail: {
              line_item_key: response.key,
              product: response
            }
          }));
        }

        if (this.cartdrawer) {
          this.cartNotification.renderContents(response);
        } else {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}



    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
